import styled from 'styled-components';

import GateKeepingListHeader from './component';

import { listHeaderStyles } from 'modules/fleet/list';

export default styled(GateKeepingListHeader)`
  ${listHeaderStyles}
`;
